import { render } from "./BookEntrance.vue?vue&type=template&id=d6af9544&scoped=true"
import script from "./BookEntrance.vue?vue&type=script&lang=js"
export * from "./BookEntrance.vue?vue&type=script&lang=js"

import "./BookEntrance.vue?vue&type=style&index=0&id=d6af9544&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-d6af9544"

export default script